import LoadingDados from "@/components/shared/LoadingDados";
import ModalValidadorDocumentos from "@/components/shared/ModalValidadorDocumentos";
import axios from "axios";
import IndexedDB from "@/mixins/IndexedDB";
import "../assets/css/validadorDocumentos.css";

export default {
    name: "ValidadorDocs",
    mixins: [IndexedDB],
    components: {LoadingDados, ModalValidadorDocumentos},
    data() {
        return {
            link_ajuda: 'https://atendimento.leiloesjudiciais.com.br/hc/pt-br',
            mensagemModal: {
                titulo: 'SEJA BEM-VINDO(A) À NOSSA PLATAFORMA!',
                paragrafo: 'Já extraímos algumas informações do seu documento.',
                paragrafoSmall: 'Por favor, prossiga o seu cadastro.',
                botao: 'clique aqui para continuar'
            },
            estilo: '',
            msg: '',
            registrarSelfie: false,
            liveness: null,
            loading: {
                loadingMgs: 'Aguarde um momento...',
                loading: false,
            },
            openModal: false,
            saudacaotxt: '',
            check_tipofile: null,
            imagePreview: [],
            selectedTipo: null,
            images: [],
            imagesFiltras: [],
            nm_file: null,
            size_file: {
                bytes: null,
                kilobytes: null,
                megabytes: null,
                prefixo: null
            },
            fileDocument: null,
            fileSelfie: null,
            tipofile: [
                {
                    nm: "OCR",
                    nm_tipofile: "ocr_padrao",
                    valor: `${process.env.VUE_APP_URL_API_NEXTCODE}` + '/full-ocr',
                    check: "checked"
                },
                {
                    nm: "FACE ID",
                    nm_tipofile: "face_id",
                    valor: `${process.env.VUE_APP_URL_API_NEXTCODE}` + '/face-match'
                }
            ],
            etapa: 1,
            textFrenteVerso: {
                titulo: 'O VERSO'
            },
            vermodal: true,
            baseUrl: location.protocol + "//" + window.location.hostname,
        };
    },
    mounted() {
        this.dadosApi();
    },
    methods: {
        fecharModal(valor) {
            this.vermodal = valor;
        },
        
        async calcularTamanhoDoArquivo(file) {
            const tamanhoEmBytes = file.size;
            const tamanhoEmKB = tamanhoEmBytes / 1024;
            const tamanhoEmMB = tamanhoEmKB / 1024;

            let prefixo = "bytes";

            if (tamanhoEmMB > 1) {
                prefixo = "MB";
            } else if (tamanhoEmKB > 1) {
                prefixo = "KB";
            }

            this.size_file = {
                bytes: tamanhoEmBytes,
                kilobytes: tamanhoEmKB.toFixed(2),
                megabytes: tamanhoEmMB.toFixed(2),
                prefixo: prefixo
            };
        },

        verFile(e, etapa) {
            const fileChooser = e.target;
            const filesToUpload = fileChooser.files;

            if (!filesToUpload || filesToUpload.length === 0) {
                this.showErrorModal(
                    'Nenhum arquivo foi selecionado.',
                    'Ops, algo deu errado...',
                    'Por favor, selecione um arquivo e tente novamente.',
                    'voltar ao início'
                );
                return;
            }

            const doc = filesToUpload[0];

            if (doc) {
                const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
                if (!allowedTypes.includes(doc.type)) {
                    alert('Tipo de arquivo não permitido. Apenas arquivos JPG, PNG, JPEG e PDF são permitidos.');
                    return;
                }
            }

            if (filesToUpload && filesToUpload[0]) {

                this.loading = {
                    loading: true,
                    loadingMgs: 'Estamos analisando a imagem enviada'
                };

                const tipo = fileChooser.getAttribute('name');

                for (const fileToUpload of filesToUpload) {
                    const reader = new FileReader();

                    reader.onload = async e => {
                        try {
                            await this.calcularTamanhoDoArquivo(fileToUpload);

                            this.images.push({
                                img: e.target.result,
                                nm_file: fileToUpload.name,
                                file: fileToUpload,
                                tipo: tipo,
                                modelo: '',
                            });

                            if (etapa == 1) {
                                const formData = new FormData();
                                formData.append(tipo, fileToUpload);

                                const documentResponse = await this.sendFormData('classify', formData);

                                if (documentResponse.data.data.length > 0 || this.images.length === 1) {
                                    const side = documentResponse.data.data[0].classification.sides[0].side;

                                    if (['FrontAndBack'].includes(side)) {
                                        this.etapa = 2;
                                        this.loading.loading = false;
                                        if (this.images.length > 2) {
                                            this.loading.loading = false;
                                            this.loading = {
                                                loading: true,
                                                loadingMgs: 'Aguarde, estamos fazendo a verificação e comparando as imagens...'
                                            };

                                            await this.saveImageToIndexedDB(this.images.map(img => ({
                                                file: img.img,
                                                nm_file: img.nm_file,
                                                tipo: img.tipo,
                                                lado: img.lado
                                            })));
                                        }
                                    } else {
                                        this.showErrorModal(
                                            'Para uma análise mais precisa, envie o documento de forma totalmente aberta, exibindo ambas as páginas (frente e verso) sem dobras ou fechamentos.',
                                            'Ops, por favor insira um documento aberto!',
                                            'Por favor, verificar os documentos e tente novamente.',
                                            'voltar ao início'
                                        );

                                        return;
                                    }
                                } else {
                                    this.showErrorModal(
                                        'Erro ocorre quando a imagem não é um documento válido ou Tamanho do arquivo excedido.',
                                        'Ops, algo deu errado... Por favor insira um documento válido!!!',
                                        'Por favor, verificar os documentos e tente novamente.',
                                        'voltar ao início'
                                    );
                                }
                            } else {
                                this.etapa = 2;
                                this.loading.loading = false;
                                if (this.images.length === 2) {
                                    this.loading = false;
                                    this.loading = {
                                        loading: true,
                                        loadingMgs: 'Aguarde, estamos fazendo a verificação e comparando as imagens...'
                                    };
                                    await this.saveImageToIndexedDB(this.images.map(img => ({
                                        file: img.img,
                                        nm_file: img.nm_file,
                                        tipo: img.tipo,
                                        lado: img.lado
                                    })));

                                    await this.valiardFile();
                                }
                            }
                        } catch (error) {
                            console.error('Erro durante a execução:', error);
                            this.showErrorModal(
                                'Ocorreu um erro inesperado durante a análise do documento.',
                                'Ops, algo deu errado...',
                                'Por favor, tente novamente mais tarde.',
                                'voltar ao início'
                            );
                        }
                    };
                    reader.readAsDataURL(fileToUpload);
                }
            } else {
                this.showErrorModal(
                    'Erro de retorno da API.',
                    'Ops, algo deu errado...',
                    'Por favor, verificar os documentos e tente novamente.',
                    'voltar ao início'
                );
            }
        },

        async processarDocumentosForm(documentos, tipoDoc = null) {
            const formData = new FormData();

            try {
                for await (const [index, subDocumentos] of documentos.entries()) {
                    // Filtrar subDocumentos pelo tipoDoc, se fornecido
                    const documentosFiltrados = tipoDoc
                        ? subDocumentos.filter(doc => doc.tipo === tipoDoc)
                        : subDocumentos;

                    for (const [posicao, documento] of documentosFiltrados.entries()) {
                        if (documento.file && typeof documento.file === 'string' && documento.file.includes(',')) {
                            try {
                                const [metadata, base64Data] = documento.file.split(',');
                                let mimetype = documento.mimetype || 'application/octet-stream';

                                if (metadata.includes(':') && metadata.includes(';')) {
                                    mimetype = metadata.split(':')[1].split(';')[0];
                                }

                                const byteCharacters = atob(base64Data);
                                const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
                                const byteArray = new Uint8Array(byteNumbers);
                                const blob = new Blob([byteArray], {type: mimetype});

                                // Adicionando ao FormData
                                formData.append(
                                    `file_anexos_${index}_${posicao}`,
                                    blob,
                                    documento.nm_file || 'sem_nome'
                                );
                            } catch (error) {
                                console.error(`Erro ao processar o documento na posição ${index}, ${posicao}: ${error.message}`);
                                throw new Error("Erro ao processar o documento.");
                            }
                        } else {
                            throw new Error(`Documento inválido ou formato incorreto na posição ${index}, ${posicao}.`);
                        }
                    }
                }
            } catch (error) {
                console.error(`Erro geral ao processar documentos: ${error.message}`);
                throw error;
            }

            return formData;
        }
        ,

        async valiardFile() {
            try {
                const formData = await this.processarDocumentosForm(await this.getImagesFromIndexedDB());
                const documentResponse = await this.sendFormData('face-match', formData);

                if (!this.handleFaceMatch(documentResponse)) return;

                if (documentResponse.data.data.matches[0].matched) {
                    this.loading = {loading: true, loadingMgs: 'Agora estamos na etapa de extração de dados...'};
                    await this.processFrontImage();
                } else {
                    this.showErrorModal('Erro na comparação da selfie com o documento com foto.');
                }
            } catch (error) {
                this.showErrorModal(`Ops, algo deu errado... Por favor, tente novamente. ${error}`);
            }
        },

        async sendFormData(url, formData) {
            return axios.post(this.baseUrl + '/core/nxt/' + url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
        },

        handleFaceMatch(documentResponse) {
            const faces = documentResponse?.data?.data?.faces;
            if (faces?.[0]?.faceType === 'Id' && faces[0].faceType === faces[1].faceType) {
                this.loading = {
                    loading: false,
                    loadingMgs: 'Ops, algo deu errado... Por favor insira um documento com foto e uma selfie.'
                };
                this.showErrorModal('Erro na comparação da selfie com o documento com foto.')

                return false;
            }

            return true;
        },

        async processFrontImage() {
            const formData = await this.processarDocumentosForm(await this.getImagesFromIndexedDB(), 'document');
            const selfieResponse = await this.sendFormData('full-ocr', formData);

            if (selfieResponse.status !== 200) {
                this.showErrorModal('Erro na comparação da selfie com o documento com foto.');
            } else {
                localStorage.setItem('apiResponse', JSON.stringify(selfieResponse.data));
                this.loading.loading = false;
                this.openModal = true;
            }
        },

        showErrorModal(
            paragrafo = null,
            titulo = null,
            paragrafoSmall = null,
            botao = null,
            reset = true
        ) {
            this.loading = {loading: false, loadingMgs: paragrafo};
            this.openModal = true;

            const modalParams = {
                paragrafo: paragrafo ?? undefined,
                titulo: titulo ?? undefined,
                paragrafoSmall: paragrafoSmall ?? undefined,
                botao: botao ?? undefined
            };

            this.mensagemModal = this.getModalContent(...Object.values(modalParams));

            if (reset)
                this.resetForm();
        },

        getModalContent(
            paragrafo = 'ERRO',
            titulo = 'Ops, algo deu errado...',
            paragrafoSmall = 'Por favor, verificar os documentos e tente novamente.',
            botao = 'voltar ao inicio'
        ) {
            return {
                titulo: titulo,
                paragrafo: paragrafo,
                paragrafoSmall: paragrafoSmall,
                botao: botao
            };
        },

        resetForm() {
            if (this.$refs.inpuitSelfie)
                this.$refs.inpuitSelfie.value = '';

            localStorage.removeItem('apiResponse_FACE_ID');
            localStorage.removeItem('apiResponse');
            localStorage.removeItem('images');
        },

        cliqueContinue() {
            window.location.reload()
        },

        async dadosApi() {
            const storedData = localStorage.getItem('apiResponse');
            try {
                if (storedData !== null) {
                    const parsedData = JSON.parse(storedData);

                    if (parsedData.data && Array.isArray(parsedData.data) && parsedData.data.length > 0) {
                        this.saudacaotxt = parsedData.data[0].extraction.person.name;
                        this.openModal = true;
                    } else {
                        console.error('A estrutura dos dados não é a esperada.');
                    }
                }
            } catch (error) {
                console.error('Erro ao analisar os dados do localStorage:', error);
            }
        }
    },

}